<template>
  <div class="maintenance">
    <div class="maintenance-card">
      <div class="maintenance-icon" aria-hidden="true">🚧</div>
      <h1 class="maintenance-title">Site Under Maintenance</h1>
      <p class="maintenance-text">
        We're currently performing scheduled updates to improve your experience.
        Please check back a little later.
      </p>

      <div class="maintenance-actions">
        <!-- <a href="/" class="btn btn-primary">Go to Home</a> -->
        <button type="button" class="btn btn-outline" @click="refresh">
          Refresh
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Maintenance",
  methods: {
    refresh() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.maintenance {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
}

.maintenance-card {
  width: 100%;
  max-width: 560px;
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  box-shadow: 0 10px 30px rgba(16, 24, 40, 0.08);
  text-align: center;
}

.maintenance-icon {
  font-size: 56px;
  line-height: 1;
  margin-bottom: 12px;
}

.maintenance-title {
  font-size: clamp(20px, 4vw, 28px);
  margin: 8px 0 12px;
  color: #0f172a; /* slate-900 */
  font-weight: 700;
}

.maintenance-text {
  font-size: 14px;
  color: #475569; /* slate-600 */
  margin: 0 auto 20px;
  max-width: 46ch;
}

.maintenance-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.btn-primary {
  background: #0ea5e9; /* sky-500 */
  color: #ffffff;
  border-color: #0ea5e9;
}
.btn-primary:hover {
  background: #0284c7; /* sky-600 */
  border-color: #0284c7;
}

.btn-outline {
  background: #ffffff;
  color: #0f172a;
  border-color: #cbd5e1; /* slate-300 */
}
.btn-outline:hover {
  background: #f1f5f9; /* slate-100 */
}

/* Mobile tweaks */
@media (max-width: 480px) {
  .maintenance-card {
    padding: 24px;
    border-radius: 12px;
  }
  .maintenance-icon {
    font-size: 48px;
  }
  .btn {
    width: 100%;
  }
}
</style>
